document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 1000);
    }
  });

  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('previewCartItem-price')) {
            const btn = document.querySelector("#cart-sidebar-checkout:not(.bss-checkout)"); 
            if (btn) {
              const newBtn = btn.cloneNode(true);
              newBtn.removeAttribute("onclick");
              newBtn.onclick = null;
              btn.parentNode.replaceChild(newBtn, btn);

              newBtn.addEventListener("click", function(e) {
                e.preventDefault();
                BSS_B2B.observer.cartSubject.listenCartCheckout();
              });
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);

    const checkBtnInterval = setInterval(() => {
      const btn = document.querySelector("#cart-checkout:not(.bss-checkout)"); 
      if (btn) {
	      clearInterval(checkBtnInterval);
        const newBtn = btn.cloneNode(true);
        newBtn.removeAttribute("onclick");
        newBtn.onclick = null;
        btn.parentNode.replaceChild(newBtn, btn);

        newBtn.addEventListener("click", function(e) {
          e.preventDefault();
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        });
      }
    }, 500);
  }

   let quickAddDrawer = document.querySelector('#main-cart-items')
                                    if (quickAddDrawer) {   
                                        let observer = new MutationObserver(function(mutations) {
                                            mutations.forEach(function(m) {
                                                if (m.addedNodes.length) {
                                                 
                                                    setTimeout(() => {
                                                      
                                                    BSS_B2B.observer.cartSubject.listenCartCheckout();
                                                    }, 500);
                                                }
                                            });
                                        });
                                        observer.observe(quickAddDrawer, {childList: true});
                                    }
 let quickAddDrawer1 = document.querySelector('.previewCart-wrapper ')
                                    if (quickAddDrawer1) {   
                                        let observer = new MutationObserver(function(mutations) {
                                            mutations.forEach(function(m) {
                                                if (m.addedNodes.length) {
                                                  BSS_B2B.observer.cartSubject.listenCartCheckout();
                                                    setTimeout(() => {
                                                      let a = document.querySelector('#cart-sidebar-checkout')
                                                      if (a) {
                                                         a.removeAttribute('bss-b2b-cart-trigger-added')
                                                      }
                                                     
                                                    BSS_B2B.observer.cartSubject.listenCartCheckout();
                                                    }, 2000);
                                                }
                                            });
                                        });
                                        observer.observe(quickAddDrawer1, {childList: true});
                                    }

});
